var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.scene.triggers),function(trigger,i){return [(i != 0)?_c('div',{key:`divider--${trigger.guid}-${i}`,staticClass:"pa-6"},[_c('v-divider')],1):_vm._e(),_c('Trigger',{key:`trigger--${trigger.guid}-${i}`,attrs:{"trigger":trigger,"scene":_vm.scene}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }